import React, {Fragment, useState} from "react";
import { Modal, Card, Table, Button, Row, Col, Toast } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux'
import {VerInformeProfesionalComponent } from 'defcol-caso-general';
import { LoadingComponent } from 'recupero-comunes'
import { MdBrightness5 } from "react-icons/md";

const ModalSolicitudesInforme = ({showModalSolicitudes, handleCloseModalSolicitudes, solicitudes}) => {
    const [loading, setLoading]=useState(false)
    const data_general = useSelector((state) => state.encargadoCompaniaReducer)
    const { llaves} = data_general

    const [showInformeProfesional, setShowInformeProfesional] = useState(false)
    const [idSolicitud, setIdSolicitud] = useState('')

    const verSolicitud = async (id) => {
        setLoading(true);   
        setIdSolicitud(id);
        setShowInformeProfesional(true);
        setLoading(false);
    }
    function ComentarioConModal({ comentario }) {
        const [show, setShow] = useState(false);

        const esLargo = comentario && comentario.length > 20;
        const textoCorto = esLargo ? comentario.substring(0, 20) + "..." : comentario;

        return (
            <>
            {textoCorto}

            {esLargo && (
                <a
                href="#"
                style={{ marginLeft: 5, fontSize: "12px" }}
                onClick={(e) => {
                    e.preventDefault();
                    setShow(true);
                }}
                >
                ver más
                </a>
            )}

            <Modal show={show} onHide={() => setShow(false)}>
                <Card>
                    <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#e8761a', color: 'white' }}>
                        Comentario completo
                    </Card.Header>
                </Card>
                <Modal.Body>{comentario}</Modal.Body>
                <Modal.Footer>
                <Button variant="secondary" onClick={() => setShow(false)}>
                    Cerrar
                </Button>
                </Modal.Footer>
            </Modal>
            </>
        );
    }
        
    return (
        <>
        <style type='text/css'>
        {`
        .btn-asignar-modal {
            background-color: #C14B49;
            color: #FFFFFF;
            width: 170px;
            padding:6px 0px 6px 0px;
        }
        .btn-asignar-modal:hover{
            background-color:  #F6897E;
            color: #FFFFFF;
        } 
        `}
    </style>
    <VerInformeProfesionalComponent
          idCaso={llaves?.idCaso}
          idSolicitud={idSolicitud}                
          showModal={showInformeProfesional}
          setShowModal={setShowInformeProfesional}
    />
    <LoadingComponent show={loading}/>
        <Modal size="xl" show={showModalSolicitudes} onHide={handleCloseModalSolicitudes}>
            <Card>
                <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#4F517A', color: 'white' }}>
                    Consulta Informes Profesionales
                </Card.Header>
                { solicitudes && solicitudes.length > 0 ? 
                    <Card.Body>                    
                        <Table striped hover>
                            <thead style={{ backgroundColor: '#010772ff', color: 'white' }}>
                                <tr>
                                    <th style={{ fontSize: '16px' }}>ID Solicitud</th>
                                    <th style={{ fontSize: '16px' }}>Tipo Info.</th>
                                    <th style={{ textAlign: 'center', fontSize: '16px' }}>Implicado</th>   
                                    <th style={{ textAlign: 'center', fontSize: '16px' }}>Fecha Solicitud</th>   
                                    <th style={{ textAlign: 'center', fontSize: '16px' }}>Fecha Autoriza</th>   
                                    <th style={{ textAlign: 'center', fontSize: '16px' }}>Gestor Asignado</th>   
                                    <th style={{ textAlign: 'center', fontSize: '16px' }}>Envío Informe</th>   
                                    <th style={{ textAlign: 'center', fontSize: '16px' }}>Estado</th>   
                                    <th style={{ textAlign: 'center', fontSize: '16px' }}>Comentario</th>   
                                    <th style={{ textAlign: 'center', fontSize: '16px' }}>Acción</th>                                    
                                </tr>
                            </thead>
                            <tbody>
                                {solicitudes && solicitudes.map((sol, index) => {
                                    return (
                                        <tr key={index}>
                                            <td>{sol.idSolicitud}</td>
                                            <td>{sol.tipoInforme}</td>
                                            <td>{sol.implicado}</td>
                                            <td>{sol.fecSolicitudFormat}</td>
                                            <td>{sol.fecAutorizaFormat}</td>
                                            <td>{sol.gestor}</td>
                                            <td>{sol.fecEnvioInformeFormat}</td>
                                            <td>{sol.estadoSolicitud}</td>
                                            <td>{<ComentarioConModal comentario={sol.comentario} />}</td>
                                            <td style={{ textAlign: 'center' }}>
                                                <Button variant='opciones me-md-2' size='sm' onClick={() => verSolicitud(sol.idSolicitud)}>
                                                    <MdBrightness5 size={20} />
                                                </Button>
                                            </td>
                                        </tr>
                                    )
                                })}                               
                            </tbody>
                        </Table>                        
                </Card.Body>
                : null }                
            </Card>
            <Modal.Footer>
                <Button className='m-2 w-auto' variant='outline-info' onClick={handleCloseModalSolicitudes}>Cerrar</Button>
            </Modal.Footer>
        </Modal>
    </>
    );
}

export default ModalSolicitudesInforme;